export default __webpack_public_path__ + "static/img_welfare_10-ee138e8aaffe752db95f388219d41c00.jpg";